"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialShareService = exports.FancySocialNetwork = exports.PinterestSocialNetwork = exports.GoogleSocialNetwork = exports.TwitterSocialNetwork = exports.FacebookSocialNetwork = void 0;
var FacebookSocialNetwork = /** @class */ (function () {
    function FacebookSocialNetwork() {
        this.type = 'facebook';
        this.baseUrl = 'http://www.facebook.com/sharer.php';
    }
    FacebookSocialNetwork.prototype.getBasUrl = function () {
        return this.baseUrl;
    };
    FacebookSocialNetwork.prototype.getQueryStringObj = function (dataObj) {
        return {
            u: dataObj.url,
            title: dataObj.title,
        };
    };
    return FacebookSocialNetwork;
}());
exports.FacebookSocialNetwork = FacebookSocialNetwork;
var TwitterSocialNetwork = /** @class */ (function () {
    function TwitterSocialNetwork() {
        this.type = 'twitter';
        this.baseUrl = 'https://twitter.com/intent/tweet';
    }
    TwitterSocialNetwork.prototype.getBasUrl = function () {
        return this.baseUrl;
    };
    TwitterSocialNetwork.prototype.getQueryStringObj = function (dataObj) {
        return {
            url: dataObj.url,
            text: dataObj.title + "\n",
        };
    };
    return TwitterSocialNetwork;
}());
exports.TwitterSocialNetwork = TwitterSocialNetwork;
var GoogleSocialNetwork = /** @class */ (function () {
    function GoogleSocialNetwork() {
        this.type = 'google';
        this.baseUrl = 'https://plus.google.com/share';
    }
    GoogleSocialNetwork.prototype.getBasUrl = function () {
        return this.baseUrl;
    };
    GoogleSocialNetwork.prototype.getQueryStringObj = function (dataObj) {
        return {
            url: dataObj.url,
        };
    };
    return GoogleSocialNetwork;
}());
exports.GoogleSocialNetwork = GoogleSocialNetwork;
var PinterestSocialNetwork = /** @class */ (function () {
    function PinterestSocialNetwork() {
        this.type = 'pinterest';
        this.baseUrl = 'http://pinterest.com/pin/create/button/';
    }
    PinterestSocialNetwork.prototype.getBasUrl = function () {
        return this.baseUrl;
    };
    PinterestSocialNetwork.prototype.getQueryStringObj = function (dataObj) {
        return {
            url: dataObj.url,
            media: dataObj.imageUrl,
            description: dataObj.title,
        };
    };
    return PinterestSocialNetwork;
}());
exports.PinterestSocialNetwork = PinterestSocialNetwork;
var FancySocialNetwork = /** @class */ (function () {
    function FancySocialNetwork() {
        this.type = 'fancy';
        this.baseUrl = 'http://www.fancy.com/fancyit/fancy';
    }
    FancySocialNetwork.prototype.getBasUrl = function () {
        return this.baseUrl;
    };
    FancySocialNetwork.prototype.getQueryStringObj = function (dataObj) {
        return {
            ItemURL: dataObj.url,
            ImageURL: dataObj.imageUrl,
            Title: dataObj.title,
        };
    };
    return FancySocialNetwork;
}());
exports.FancySocialNetwork = FancySocialNetwork;
var SocialShareService = /** @class */ (function () {
    function SocialShareService() {
    }
    SocialShareService.prototype.getSocialNetworkUrl = function (socialNetwork, dataObj) {
        var queryStringObj = socialNetwork.getQueryStringObj(dataObj);
        var queryParams = Object.keys(queryStringObj)
            .map(function (prop) {
            return prop + "=" + encodeURIComponent(queryStringObj[prop])
                .replace(/%20/g, '+')
                .replace(/\*/g, '%2A');
        })
            .join('&');
        return socialNetwork.getBasUrl() + "?" + queryParams;
    };
    return SocialShareService;
}());
exports.SocialShareService = SocialShareService;
